import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { ModalBody as CoreModalBody } from '@vds-core/modals';
import { TypographyConfig, BodyConfig } from '@vds/typography';
import { calculateSpacing } from '@vds-core/theme';
var typescale = TypographyConfig.getTypescale();

var ModalBody = function ModalBody(props) {
  function _calcTypography(bodyConfig, viewport, typescale) {
    var size = viewport === 'mobile' ? 'small' : 'medium';
    return BodyConfig.getStyles(typescale, viewport, size);
  }

  return /*#__PURE__*/React.createElement(CoreModalBody, _extends({}, props, {
    typescale: typescale,
    bodyConfig: BodyConfig,
    calcTypography: _calcTypography,
    padding: calculateSpacing('4X')
  }));
};

export default ModalBody;